import { render, staticRenderFns } from "./WalletConnectQr.htm?vue&type=template&id=d203c1a2&scoped=true&"
import script from "./WalletConnectQr.ts?vue&type=script&lang=js&"
export * from "./WalletConnectQr.ts?vue&type=script&lang=js&"
import style0 from "./WalletConnectQr.scss?vue&type=style&index=0&id=d203c1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d203c1a2",
  null
  
)

export default component.exports